import React from "react";

const AboutUs = () => {
  return (
    <section className="bg-[#FEF7ED] py-8 md:py-10 px-4 sm:px-6 md:px-16 font-[Poppins]">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-8">
        {/* Left: Image (Smaller) */}
        <div className="w-full md:w-1/3 flex justify-center">
          <img 
            src={"https://ik.imagekit.io/bhavishya/web-final/LandingPage/about2.png"} 
            alt="About Bhavishya NGO" 
            className="w-3/4 sm:w-2/3 md:w-full max-w-xs rounded-lg"
          />
        </div>

        {/* Right: Text Content */}
        <div className="w-full md:w-2/3 text-center md:text-left md:pl-4 lg:pl-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            About Us
          </h2>
          <p className="text-base sm:text-lg text-gray-700 mb-6 leading-relaxed">
            At <span className="font-semibold">Bhavishya NGO</span>, we believe that{" "}
            <span className="text-orange-600 font-medium">every child deserves access to quality education</span>.
            Our mission is to <span className="font-semibold">empower underprivileged children </span> 
            by providing free education, digital literacy, and skill development programs.
            Since our inception, we have transformed countless lives, bridging the education gap
            and creating brighter futures.
          </p>
          <a
            href="/about"
            className="inline-block bg-[#EB5A57] text-white font-semibold py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:bg-[#d94f4c] transition duration-300 text-sm sm:text-base">
            Read Our Story
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;